var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("div", [
        _c("table", [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._m(1),
              _vm._v(" "),
              _vm._l(_vm.table1["class1_letters"], function(data, index) {
                return _c("tr", [
                  _c("td", [_vm._v(_vm._s(index))]),
                  _vm._v(" "),
                  _c("td", [_vm._v("£" + _vm._s(data["stamps"].toFixed(2)))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("£" + _vm._s(data["standard_franking"].toFixed(2)))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("£" + _vm._s(data["mailmark_franking"].toFixed(2)))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("£" + _vm._s(data["stamps_saving"].toFixed(2)))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("£" + _vm._s(data["franking_saving"].toFixed(2)))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    index === "Standard letter" && !data["volumes"]
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.table1["class1_post_percentage_value"])
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index === "Standard letter" && data["volumes"]
                      ? _c("span", [_vm._v(_vm._s(data["volumes"]))])
                      : _vm._e(),
                    _vm._v(" "),
                    index !== "Standard letter"
                      ? _c("span", [_vm._v(_vm._s(data["volumes"]))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        data["stamps_saving_total"]
                          ? "£" + data["stamps_saving_total"].toFixed(2)
                          : null
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        data["franking_saving_total"]
                          ? "£" + data["franking_saving_total"].toFixed(2)
                          : null
                      )
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._l(_vm.table1["class2_letters"], function(data, index) {
                return _c("tr", [
                  _c("td", [_vm._v(_vm._s(index))]),
                  _vm._v(" "),
                  _c("td", [_vm._v("£" + _vm._s(data["stamps"].toFixed(2)))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("£" + _vm._s(data["standard_franking"].toFixed(2)))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("£" + _vm._s(data["mailmark_franking"].toFixed(2)))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("£" + _vm._s(data["stamps_saving"].toFixed(2)))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("£" + _vm._s(data["franking_saving"].toFixed(2)))
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    index === "Standard letter" && !data["volumes"]
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.table1["class2_post_percentage_value"])
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index === "Standard letter" && data["volumes"]
                      ? _c("span", [_vm._v(_vm._s(data["volumes"]))])
                      : _vm._e(),
                    _vm._v(" "),
                    index !== "Standard letter"
                      ? _c("span", [_vm._v(_vm._s(data["volumes"]))])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        data["stamps_saving_total"]
                          ? "£" + data["stamps_saving_total"].toFixed(2)
                          : null
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        data["franking_saving_total"]
                          ? "£" + data["franking_saving_total"].toFixed(2)
                          : null
                      )
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _c("tr", [
                _vm._m(3),
                _vm._v(" "),
                _c("td", [
                  _c("h6", [
                    _c("b", [_vm._v("I89")]),
                    _vm._v(
                      " £" +
                        _vm._s(_vm.table1["totals"]["stamps_saving"].toFixed(2))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("h6", [
                    _c("b", [_vm._v("I90")]),
                    _vm._v(
                      " £" +
                        _vm._s(
                          _vm.table1["totals"]["franking_saving"].toFixed(2)
                        )
                    )
                  ])
                ])
              ])
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-top": "20px" } }, [
        _c("table", [
          _vm._m(4),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("b", [_vm._v("C1")]),
              _vm._v(" " + _vm._s(_vm.results.letters) + "\n          ")
            ]),
            _vm._v(" "),
            _c("td", [
              _c("b", [_vm._v("C2")]),
              _vm._v(" " + _vm._s(_vm.results.packets))
            ]),
            _vm._v(" "),
            _c("td", [
              _c("b", [_vm._v("C3")]),
              _vm._v(" " + _vm._s(_vm.results.total))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("table", { staticStyle: { "margin-top": "10px" } }, [
          _c("tr", [
            _c("td", [_vm._v("Equipment lease costs")]),
            _vm._v(" "),
            _c("td", [
              _c("b", [_vm._v("C8")]),
              _vm._v(
                " £" +
                  _vm._s(_vm.current_costs["equipment_lease_costs"].toFixed(2))
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Service costs (if purchased or paid annually)")]),
            _vm._v(" "),
            _c("td", [
              _c("b", [_vm._v("C9")]),
              _vm._v(
                " £" + _vm._s(_vm.current_costs["service_costs"].toFixed(2))
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Consumable Ink costs")]),
            _vm._v(" "),
            _c("td", [
              _c("b", [_vm._v("C10")]),
              _vm._v(
                " £" +
                  _vm._s(_vm.current_costs["consumable_ink_costs"].toFixed(2))
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Consumable label costs")]),
            _vm._v(" "),
            _c("td", [
              _c("b", [_vm._v("C11")]),
              _vm._v(
                " £" +
                  _vm._s(_vm.current_costs["consumable_label_costs"].toFixed(2))
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Postage Recredit costs")]),
            _vm._v(" "),
            _c("td", [
              _c("b", [_vm._v("C12")]),
              _vm._v(
                " £" +
                  _vm._s(
                    _vm.current_costs["postage_recredit_costs"].toFixed(2)
                  ) +
                  "\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Invoice Fees")]),
            _vm._v(" "),
            _c("td", [
              _c("b", [_vm._v("C13")]),
              _vm._v(
                " £" + _vm._s(_vm.current_costs["invoice_fees"].toFixed(2))
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Insurance Fees")]),
            _vm._v(" "),
            _c("td", [
              _c("b", [_vm._v("C14")]),
              _vm._v(
                " £" + _vm._s(_vm.current_costs["insurance_fees"].toFixed(2))
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("TOTAL COST PER ANNUM")]),
            _vm._v(" "),
            _c("td", [
              _c("b", [_vm._v("C15")]),
              _vm._v(
                " £" +
                  _vm._s(_vm.current_costs["total_cost_per_annum"].toFixed(2)) +
                  " "
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("td", [_vm._v("Format")]),
        _vm._v(" "),
        _c("td", [_vm._v("Stamps")]),
        _vm._v(" "),
        _c("td", [_vm._v("Standard Franking")]),
        _vm._v(" "),
        _c("td", [_vm._v("Mailmark Franking")]),
        _vm._v(" "),
        _c("td", [_vm._v("Stamps to Mailmark Saving")]),
        _vm._v(" "),
        _c("td", [_vm._v("Franking to Mailmark Saving")]),
        _vm._v(" "),
        _c("td", [_vm._v("VOLUMES")]),
        _vm._v(" "),
        _c("td", [_vm._v("Stamps to Mailmark SAVING TOTAL")]),
        _vm._v(" "),
        _c("td", [_vm._v("Franking to Mailmark SAVING TOTAL")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "12" } }, [
        _c("h4", [_vm._v("1st class mail")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "12" } }, [
        _c("h4", [_vm._v("2nd class mail")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "7" } }, [
      _c("h4", [_vm._v("Total savings: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("LETTERS")]),
      _vm._v(" "),
      _c("td", [_vm._v("PACKETS")]),
      _vm._v(" "),
      _c("td", [_vm._v("TOTAL")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-223f8c7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-223f8c7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Debug/QuoteInfo/CalculationTables.vue
// module id = null
// module chunks = 